import { render, staticRenderFns } from "./Permalink.vue?vue&type=template&id=6f64b717&"
import script from "./Permalink.vue?vue&type=script&lang=js&"
export * from "./Permalink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports